import React from 'react';
import { useSelector } from 'react-redux';
import { selectToasts } from './toastSlice';
import { Toast } from './Toast';
import classes from './ToastContainer.module.css';

export const ToastContainer = () => {
    const toasts = useSelector(selectToasts);

    if (toasts.length === 0) {
        return null;
    }

    return (
        <div className={classes.ToastContainer}>
            {toasts.map(toast => (
                <Toast
                    key={toast.id}
                    {...toast}
                />
            ))}
        </div>
    );
};
